import { createMemo } from "solid-js"
import { LinkButton } from "./button"
import { listClass, paginationClass } from "./pagination.css"

type Props = {
  page: number
  totalPages: number
  paginationPath: (page: number) => string
}

export function Pagination(props: Props) {
  const nextUrl = createMemo(() => props.paginationPath(props.page + 1))
  const prevUrl = createMemo(() => props.paginationPath(props.page - 1))

  return (
    <nav class={paginationClass}>
      <ul class={listClass}>
        {props.page > 1 && (
          <li>
            <LinkButton hue="sand" iconName="arrow-left" href={prevUrl()}>
              prev
            </LinkButton>
          </li>
        )}

        {props.page < props.totalPages && (
          <li>
            <LinkButton hue="sand" iconName="arrow-right" href={nextUrl()}>
              next
            </LinkButton>
          </li>
        )}
      </ul>
    </nav>
  )
}
